import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { getPaginationParams } from '../../selectors'
import { Numbers, Next, Prev } from 'SRC/modules/common/components/Pagination'
import { getAdsWithPromosQuery } from 'SRC/modules/ads/list/selectors'

export class ProfileAds extends React.PureComponent {
  getPageCount = () => Math.ceil((this.props.paginationParams.count) / this.props.paginationParams.countPerPage)

  getPages = (pageCount = 1) => {
    const { queryParams } = this.props

    const pages = []
    const baseUrl = this.getBaseUrl()
    const current = Number(this.props.paginationParams.currentPage)
    for (let i = 1; i <= pageCount; i++) {
      pages.push({
        number: i,
        isCurrent: i === current,
        href: { pathname: baseUrl.href, query: { ...queryParams, page: i } },
        as: { pathname: `${baseUrl.as}/${i}`, query: queryParams }
      })
    }
    return pages
  }

  getBaseUrl = () => ({href: `/activatePromoCKB`, as: `/online-placanje`})

  getPrevUrl = () => {
    const { paginationParams, queryParams } = this.props
    const baseUrl = this.getBaseUrl()

    return {
      href: {
        pathname: baseUrl.href,
        query: { ...queryParams, page: Number(paginationParams.currentPage) - 1
        }
      },
      as: {
        pathname: `${baseUrl.as}/${Number(paginationParams.currentPage) - 1}`,
        query: queryParams
      }
    }
  }

  getNextUrl = () => {
    const { paginationParams, queryParams } = this.props
    const baseUrl = this.getBaseUrl()

    return {
      href: {
        pathname: baseUrl.href,
        query: { ...queryParams, page: Number(paginationParams.currentPage) + 1
        }
      },
      as: {
        pathname: `${baseUrl.as}/${Number(paginationParams.currentPage) + 1}`,
        query: queryParams
      }
    }
  }

  render () {
    const pageCount = this.getPageCount()
    const pages = this.getPages(pageCount)
    const currentPage = Number(this.props.paginationParams.currentPage)
    const isFirstPage = currentPage === 1
    const isLastPage = currentPage === pageCount
    const prevUrl = this.getPrevUrl()
    const nextUrl = this.getNextUrl()

    return pageCount > 0
      ? <div className='poruke-pagination'>
        <ul id='page-numbers' className='ads-pagination'>
          <Prev isFirstPage={isFirstPage} href={prevUrl.href} as={prevUrl.as} />
          <Numbers pages={pages} />
          <Next isLastPage={isLastPage} href={nextUrl.href} as={nextUrl.as} />
        </ul>
      </div>
      : null
  }
}

const mapStateToProps = state => ({
  paginationParams: getPaginationParams(state),
  queryParams: getAdsWithPromosQuery(state)
})

ProfileAds.propTypes = {
  paginationParams: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    countPerPage: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired
  }).isRequired,
  queryParams: PropTypes.shape()
}

export default connect(mapStateToProps)(ProfileAds)
